import Vue from 'vue'
import VueRouter from 'vue-router'
// 配置router路由
import Import from '../../pages/Import.vue'
import Home from '../../pages/Home.vue'
import Collate from '../../pages/Collate.vue'
import Diagram from '../../pages/Diagram.vue'
import DiagramRecord from '../../pages/diagram/DiagramRecord.vue'
import DiagramDetail from '../../pages/diagram/DiagramDetail.vue'
import DiagramEdit from '../../pages/diagram/DiagramEdit.vue'
import Calendar from '../../pages/Calendar.vue'
import Record from '../../pages/Record.vue'
import Detail from '../../pages/Detail.vue'
import Share from '../../pages/Share.vue'
import Search from '../../pages/Search.vue'
import Comment from '../../pages/comment/Comment.vue'
import OtherComment from '../../pages/comment/OtherComment.vue'
import DiscussPage from '../../pages/Discuss.vue'
import DiscussSecond from '../../pages/discuss/DiscussSecond.vue'
import DiscussList from '../../pages/discuss/DiscussList.vue'
import Discuss from '../../pages/discuss/Discuss.vue'
import DiscussChoosePeople from '../../pages/discuss/DiscussChoosePeople.vue'
import DiscussCreate from '../../pages/discuss/DiscussCreate.vue'
import ChooseGroup from '../../pages/subpages/ChooseGroup.vue'
import ChooseDiagram from '../../pages/subpages/ChooseDiagram.vue'
import GroupManage from '../../pages/subpages/GroupManage.vue'
import AllRecord from '../../pages/subpages/AllRecord.vue'
import EditDetail from '../../pages/subpages/EditDetail.vue'
import DetailHeHuaChong from '../../pages/subpages/DetailHeHuaChong.vue'
import AdvancedSearch from '../../pages/subpages/AdvancedSearch.vue'
import SearchResult from '../../pages/subpages/SearchResult.vue'
import AdvancedCollate from '../../pages/subpages/AdvancedCollate.vue'
import Label from '../../pages/subpages/Label.vue'
import LabelManage from '../../pages/subpages/LabelManage.vue'
import Embedded from '../../pages/embedded/Embedded.vue'
import Donate from '../../pages/donate/Donate.vue'
import DonateForm from '../../pages/donate/DonateForm.vue'
import Report from '../../pages/report/Report.vue'
import Nature from '../../pages/nature/Nature.vue'
import ChooseRecord from '../../pages/subpages/ChooseRecord.vue'
import ChooseCreateNew from '../../pages/subpages/ChooseCreateNew.vue'
import FamousPedia from '../../pages/famouspedia/FamousPedia.vue'
import FamousPediaRead from '../../pages/famouspedia/FamousPediaRead.vue'
import FamousPediaCreate from '../../pages/famouspedia/FamousPediaCreate.vue'
import FamousPediaInform from '../../pages/inform/FamousPediaInform.vue'
import FamousPediaEdit from '../../pages/famouspedia/FamousPediaEdit.vue'
import FamousPediaEditHistory from '../../pages/famouspedia/FamousPediaEditHistory.vue'
import My from '../../pages/my/My.vue'
import MySet from '../../pages/my/MySet.vue'
import MySetTelephone from '../../pages/my/MySetTelephone.vue'
import MySetPassword from '../../pages/my/MySetPassword.vue'
import MySetUI from '../../pages/my/MySetUI.vue'
import MyGet from '../../pages/my/MyGet.vue'
import MyGetSelect from '../../pages/my/MyGetSelect.vue'
import MySendSelect from '../../pages/my/MySendSelect.vue'
import MySendGetCode from '../../pages/my/MySendGetCode.vue'
import MyExportFile from '../../pages/my/MyExportFile.vue'
import Contrast from '../../pages/contrast/Contrast.vue'
import ContrastList from '../../pages/contrast/ContrastList.vue'
import CourseRecord from '../../pages/course/CourseRecord.vue'
import CourseList from '../../pages/course/CourseList.vue'
import CourseDetail from '../../pages/course/CourseDetail.vue'
import Course from '../../pages/course/Course.vue'
import Strong from '../../pages/strong/Home.vue'
import MyReport from '../../pages/strong/MyReport.vue'
import StrongReport from '../../pages/strong/Report.vue'
import Generate from '../../pages/strong/Generate.vue'
import YearCharacter from '../../pages/year/YearCharacter.vue'
import YearReport from '../../pages/year/YearReport.vue'
import Marriage from '../../pages/Marriage.vue'
import MarriageVerify from '../../pages/marriage/MarriageVerify.vue'
import MarriageRecord from '../../pages/marriage/MarriageRecord.vue'
import MarriageReportOne from '../../pages/marriage/MarriageReportOne.vue'
import MarriageReportTwo from '../../pages/marriage/MarriageReportTwo.vue'
import MarriageGenerate from '../../pages/marriage/MarriageGenerate.vue'
import Dress from '../../pages/dress/Dress.vue'

import { SHARE } from '../share'
import store from '../store'
import { RECORD_DOM } from '../dom'
import { CONFIG } from '../config'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
}
Vue.use(VueRouter);

/**
 * 定义路由
 */
export default new VueRouter({
    base: CONFIG.platform != 'wechat' ? '/'+CONFIG.platform+'/' : '/',
    mode: 'history',
    routes: [
        {
            path: '/import',
            component: Import,
            meta: {
                // 路由层级，数值越大层级越深，以此决定转场动画的前进和后退 大于前进，小于后退
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/home',
            component: Home,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/collate',
            component: Collate,
            meta: {
                index: 0,
                showFooter: true,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'advancedcollate',
                    component: AdvancedCollate
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                }
            ],
            beforeEnter: (to, from, next) => {
                var fromPath = from.path;
                if(fromPath.indexOf('detail/collate_advancedcollate') == -1) {
                    // 重置表单数据
                    store.dispatch('collate/resetData');
                    store.dispatch('group/resetChooseGroupData');
                    // 重置标签页数据
                    store.dispatch('label/resetData');
                }
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/diagram',
            component: Diagram,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosediagram/:from',
                    component: ChooseDiagram
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/diagramrecord',
            component: DiagramRecord,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosediagram/:from',
                    component: ChooseDiagram
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/diagramdetail/:id',
            component: DiagramDetail,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/diagramedit/:id',
            component: DiagramEdit,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosediagram/:from',
                    component: ChooseDiagram
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/record',
            component: Record,
            meta: {
                index: 0,
                showFooter: true,
                bodyGray: true
            },
            children: [
                {
                    path: 'groupmanage',
                    component: GroupManage
                },
                {
                    path: 'all',
                    component: AllRecord
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
                setTimeout(() => {
                    RECORD_DOM.resetRecordListContentStyle();
                }, 300);
            }
        },
        {
            path: '/discussmain',
            component: DiscussPage,
            meta: {
                index: 0,
                showFooter: true,
            },
            children: [
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
                {
                    path: 'choosecreate',
                    component: ChooseCreateNew,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                    ]
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/discusssecond',
            component: DiscussSecond,
            meta: {
                index: 0,
                showFooter: false,
            },
            children: [
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
                {
                    path: 'choosecreate',
                    component: ChooseCreateNew,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                    ]
                }
            ],
        },
        {
            path: '/detail/:from/:id',
            component: Detail,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                },
                {
                    path: 'setui',
                    component: MySetUI
                },
                {
                    path: 'hehuachong',
                    component: DetailHeHuaChong
                }
            ]
        },
        {
            path: '/edit/:from/:id',
            component: EditDetail,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'label',
                    component: Label
                }
            ]
        },
        {
            path: '/search/:from',
            component: Search,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'advanced',
                    component: AdvancedSearch
                },
                {
                    path: 'result',
                    component: SearchResult
                },
                {
                    path: 'label',
                    component: Label
                }
            ]
        },
        {
            path: '/comment/:from/:id',
            component: Comment,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/othercomment',
            component: OtherComment,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/discusslist/:id',
            component: DiscussList,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/discusscreate',
            component: DiscussCreate,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true,
            }
        },
        {
            path: '/discuss/:from/:id',
            component: Discuss,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosepeople',
                    component: DiscussChoosePeople,
                },
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
            ]
        },
        {
            path: '/report/:from/:id',
            component: Report,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/nature/:from/:id',
            component: Nature,
            meta: {
                index: 0,
                showFooter: false,
            }
        },
        {
            path: '/share',
            component: Share,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'detail/:id',
                    component: Detail,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                        {
                            path: 'setui',
                            component: MySetUI
                        },
                        {
                            path: 'hehuachong',
                            component: DetailHeHuaChong
                        }
                    ]
                },
                {
                    path: 'comment/:id',
                    component: Comment,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'discuss/:frompage/:id',
                    component: Discuss,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'choosepeople',
                            component: DiscussChoosePeople,
                        }
                    ]
                },
                {
                    path: 'famouspediaread/:id/:frompage',
                    component: FamousPediaRead,
                    meta: {
                        index: 1,
                        showFooter: false
                    },
                    children: [
                        {
                            path: 'edithistory',
                            component: FamousPediaEditHistory
                        },
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]                    
                },
                {
                    path: 'diagramdetail/:id',
                    component: DiagramDetail,
                },
                {
                    path: 'marriagereportone/:id',
                    component: MarriageReportOne, 
                },
                {
                    path: 'marriagereporttwo/:id',
                    component: MarriageReportTwo, 
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/embedded',
            component: Embedded,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'comment',
                    component: Comment,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'othercomment',
                    component: OtherComment
                },
                {
                    path: 'discusslist',
                    component: DiscussList
                },
                {
                    path: 'discuss',
                    component: Discuss,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'report',
                    component: Report
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                },
                {
                    path: 'famouspediaread',
                    component: FamousPediaRead,
                    children: [
                        {
                            path: 'edithistory',
                            component: FamousPediaEditHistory
                        },
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ],
                },
                {
                    path: 'famouspediaedit',
                    component: FamousPediaEdit
                },
                {
                    path: 'famouspediacreate',
                    component: FamousPediaCreate,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                        {
                            path: 'chooserecord',
                            component: ChooseRecord,
                            children: [
                                {
                                    path: 'all',
                                    component: AllRecord
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'diagram',
                    component: Diagram,
                    meta: {
                        index: 0,
                        showFooter: false,
                        bodyGray: true
                    },
                    children: [
                        {
                            path: 'choosediagram/:from',
                            component: ChooseDiagram
                        }
                    ],
                    beforeEnter: (to, from, next) => {
                        next();
                        setTimeout(() => {
                            store.state.public.curPath = to.path;
                            SHARE.initConfigShare();
                        }, 100);
                    }
                },
                {
                    path: 'diagramrecord',
                    component: DiagramRecord,
                    meta: {
                        index: 0,
                        showFooter: false,
                        bodyGray: true
                    },
                    children: [
                        {
                            path: 'choosediagram/:from',
                            component: ChooseDiagram
                        }
                    ]
                },
                {
                    path: 'diagramdetail/:id',
                    component: DiagramDetail,
                    meta: {
                        index: 0,
                        showFooter: false,
                        bodyGray: true
                    }
                },
                {
                    path: 'diagramedit/:id',
                    component: DiagramEdit,
                    meta: {
                        index: 0,
                        showFooter: false,
                        bodyGray: true
                    },
                    children: [
                        {
                            path: 'choosediagram/:from',
                            component: ChooseDiagram
                        }
                    ],
                },
            ]
        },
        {
            path: '/donate/:frompage',
            component: Donate,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'form',
                    component: DonateForm,
                    beforeEnter: (to, from, next) => {
                        next();
                        setTimeout(() => {
                            SHARE.initConfigShare();
                        }, 100);
                    }
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspedia',
            component: FamousPedia,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'inform',
                    component: FamousPediaInform
                },
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
                {
                    path: 'choosecreate',
                    component: ChooseCreateNew,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                    ]
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediacreate',
            component: FamousPediaCreate,
            meta: {
                index: 1,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediaread/:id/:frompage',
            component: FamousPediaRead,
            meta: {
                index: 1,
                showFooter: false,
                bodyGray: true
            },
            children: [
                {
                    path: 'edithistory',
                    component: FamousPediaEditHistory
                },
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediaedit',
            component: FamousPediaEdit,
            meta: {
                index: 1,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/my',
            component: My,
            meta: {
                index: 0,
                showFooter: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
            children: [
                {
                    path: 'myset',
                    component: MySet
                },
                {
                    path: 'settel',
                    component: MySetTelephone
                },
                {
                    path: 'setpwd',
                    component: MySetPassword
                },
                {
                    path: 'setui',
                    component: MySetUI
                },
                {
                    path: 'getbz',
                    component: MyGet
                },
                {
                    path: 'getbzselect',
                    component: MyGetSelect,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'sendbzselect',
                    component: MySendSelect,
                },
                {
                    path: 'sendbzcode',
                    component: MySendGetCode
                },
                {
                    path: 'exportfile',
                    component: MyExportFile
                }
            ]
        },
        {
            path: '/calendar',
            component: Calendar,
            meta: {
                index: 0,
                showFooter: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/contrast/:frompage/:id',
            component: Contrast,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/contrastlist/:frompage',
            component: ContrastList,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/courserecord',
            component: CourseRecord,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/courselist/:from',
            component: CourseList,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/coursedetail/:id',
            component: CourseDetail,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/course/:from/:id',
            component: Course,
            meta: {
                index: 0,
                showFooter: false
            },
            children: [
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/strong',
            component: Strong,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        },
        {
            path: '/strong-myreport',
            component: MyReport,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        },
        {
            path: '/strong-report/:id',
            component: StrongReport,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        },
        {
            path: '/generate/:from',
            component: Generate,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        },
        {
            path: '/yearcharacter/:from/:id',
            component: YearCharacter,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/year/:from/:id',
            component: YearReport,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/marriage',
            component: Marriage,
            children: [
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                },
                {
                    path: 'choosecreate',
                    component: ChooseCreateNew,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        },
                    ]
                }
            ],
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
        },
        {
            path: '/marriageverify',
            component: MarriageVerify,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/marriagegenerate',
            component: MarriageGenerate,
            meta: {
                index: 0,
                showFooter: false
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        },
        {
            path: '/marriagerecord',
            component: MarriageRecord,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            }
        },
        {
            path: '/marriagereportone/:id',
            component: MarriageReportOne,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/marriagereporttwo/:id',
            component: MarriageReportTwo,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            },
        },
        {
            path: '/dress',
            component: Dress,
            meta: {
                index: 0,
                showFooter: false,
                bodyGray: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                }, 100);
            },
        }
    ]
});